<div *ngIf="!shouldHide()">

  <!-- gif -->
  <div class="chatbot-toggle" (click)="toggleChat()" *ngIf="!isOpen">
    <img src="assets/images/chatbot.png" alt="Chatbot" />
    <div class="help-bubble" *ngIf="!isOpen && showHelpBubble">Any Help?</div>
  </div>


  <!-- Chat Window -->
  <div class="chatbot-window" *ngIf="isOpen">

    <div class="chat-header">
      <span>Chatbot</span>
      <button (click)="closeChat()">✖</button>
    </div>

   <div class="chat-messages" #scrollMe>
  <span class="welcome-text">👋 Hi! I'm your assistant. Ask me anything.</span>

  <div *ngFor="let msg of messages" class="message-wrapper" [ngClass]="msg.sender">
    <img
      *ngIf="msg.sender === 'user'"
      src="assets/images/user-icon.png"
      alt="User"
      class="message-icon"
    />
    <img
      *ngIf="msg.sender === 'bot'"
      src="assets/images/bot-icon.png"
      alt="Bot"
      class="message-icon"
    />

    <div class="message-text">{{ msg.text }}</div>
  </div>

  <div *ngIf="loading" class="bot typing-indicator">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</div>

  <div class="chat-input">
    <input [(ngModel)]="question" placeholder="Ask something..." (keydown.enter)="sendMessage()" />
    <button (click)="sendMessage()">Send</button>
  </div>

</div>

</div>